import React from "react";
import logo from "../../assets/logos/WhiteLogo.png";
import { SignoutIcon, SignoutIconBlack } from "../../assets/icons/icons";
import IconButton from "../shared/IconButton";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/userInfoSlice";
/**
 * A shared header component for the application.
 * Displays the app logo, user info, and a Sign Out button.
 *
 * @param {object} props - The component's props.
 * @param {boolean} [props.isAnalytics=false] - A flag to indicate if the header is used on an analytics page,
 * @returns {React.ReactElement} The rendered header component (JSX).
 */
function Header({ isAnalytics }) {
  
  /* ****************************************************************
  *                             STATES                              *
  ******************************************************************/

  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);
  const IconToUse = SignoutIconBlack;
  const hoverColor = "hover:bg-gray-300";
  const bgColor = "bg-[var(--button-color)]";

  return (
    <header className={`px-4 md:px-6 py-3 md:py-4 top-0 z-50  bg-[var(--primary-bg-color)]`
    }>
      <div className="flex items-center justify-between">
        {/* Left Section — Logo + App Info */}
        <div className="flex items-center space-x-3">
          {/* Logo */}
          <div className="w-9 h-9 bg-[var(--color-primary)] rounded-full flex items-center justify-center">
            <img className="h-6" src={logo} alt="SparkMotion Logo" />
          </div>

          {/* App Name + User Info (hidden on mobile) */}
          <div className="hidden sm:block">
            <h1 className={`text-xl font-semibold   text-[var(--primary-text-color)]`}>
              SparkMotion {userInfo.user.role}
            </h1>
            <p className="text-sm text-gray-400">
              Welcome back, {userInfo.user.email}
            </p>
          </div>
        </div>

        {/* Right Section — Sign Out Button */}
        {/* Full button on desktop, icon-only on mobile */}
        <div>
          <div className="hidden md:block">
            <IconButton
              icon={IconToUse}
              label="Sign Out"
              onClick={() => dispatch(logout())}
              hoverColor={hoverColor}
              bgColor={bgColor}
              border={true}
              color={'black'}
            />
          </div>
          {/* Signout Button */}
          <button
            onClick={() => dispatch(logout())}
            className="md:hidden p-2 rounded-full bg-[#2626264D] hover:bg-gray-600 transition-colors duration-200"
          >
            <SignoutIcon className=" w-5 h-5" />
          </button>
        </div>
      </div>
    </header >
  );
}

export default Header;
